import type { ParsedUrlQuery } from 'querystring';

import type { BasicPaginationMeta } from 'Components/Pagination/Pagination.types';

export const resolveQueryParamsWithPage = (pageNumber: number, otherQueryParams?: ParsedUrlQuery): ParsedUrlQuery => ({
	...otherQueryParams,
	page: `${pageNumber}`,
});

export const getCircles = ({
	itemsPerPage,
	pageNumber,
	totalItemsCount,
}: Pick<BasicPaginationMeta, 'itemsPerPage' | 'pageNumber' | 'totalItemsCount'>): number[] => {
	const all = Array.from(Array(Math.ceil(itemsPerPage ? totalItemsCount / itemsPerPage : 0)), (_, index) => index + 1);
	if (all.length <= 5) {
		return all;
	}
	if (pageNumber >= all.length - 2) {
		return all.slice(all.length - 5, all.length);
	}
	return all.slice(Math.max(Math.min(pageNumber - 3), 0), Math.max(pageNumber + 2, 5));
};
